import moment from 'moment';
import { VisaDocumentProps } from '../../types';

export const useVisaDocumentFR = (eventDates: VisaDocumentProps['event']['dates']) => {
  const getEventDates = () => {
    const sortedDates = [...eventDates].sort((a, b) => (moment(a.localStartTime).isBefore(moment(b.localStartTime)) ? -1 : 1));
    const startDate = sortedDates[0].localStartTime;
    const endDate = sortedDates.pop()?.localEndTime;
    const startDateDisplayYear = moment(startDate).format('YYYY');
    const startDateMonth = moment(startDate).month();
    const endDateMonth = moment(endDate).month();
    const startDateYear = moment(startDate).year();
    const endDateYear = moment(endDate).year();
    const dates = {
      startDate: moment(startDate).format('DD MMMM'),
      endDate: moment(endDate).format('DD MMMM YYYY'),
      startDateDisplayYear
    };
    if (startDateMonth === endDateMonth) {
      dates.startDate = moment(startDate).format('DD');
    }
    if (startDateYear !== endDateYear) {
      dates.startDate = moment(startDate).format('DD MMMM YYYY');
    }
    return dates;
  };

  return getEventDates();
};
